import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  containerized: {
    type: 'boolean',
    default: false,
  },
  thead: {
    type: 'boolean',
    default: true,
  },
  tfoot: {
    type: 'boolean',
    default: false,
  },
  lines: {
    type: 'int',
    default: 1,
  },
  columns: {
    type: 'int',
    default: 3,
  },
  labels: {
    type: `Array`,
    default: [
      {
        key: 'thead',
        columns: Array(3),
      },
      {
        key: 'tfoot',
        columns: Array(3),
      },
    ],
  },
  content: {
    type: `Array`,
    default: [
      {
        columns: Array(3),
      },
    ],
  },
  variant: {
    type: 'string',
    default: 'default',
  },
  ...Common,
};
